// Faz o Enter se comportar como Tab dentro de telas de cadastro: pula pro
// próximo campo visível em vez de deixar o Enter sem efeito (ou submeter
// sem querer). No último campo, foca o botão marcado com data-enter-final
// (ex.: "Salvar") em vez de disparar a ação direto — evita salvar sem querer,
// o usuário confirma com mais um Enter/clique.
//
// Uso: onKeyDown={navegarComEnter} num container com data-enter-scope="on"
// (normalmente o wrapper da tela/form) e data-enter-final no botão de salvar.
// Modais aninhados (busca, seleção) que já têm sua própria lógica de Enter
// devem marcar seu wrapper com data-enter-scope="off" para ficar de fora.
const SELETOR_CAMPO = 'input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)';

export function navegarComEnter(e) {
  if (e.key !== 'Enter') return;
  const alvo = e.target;
  if (alvo.tagName === 'TEXTAREA' || alvo.tagName === 'BUTTON') return;

  const escopo = alvo.closest('[data-enter-scope]');
  if (!escopo || escopo.dataset.enterScope === 'off') return;

  e.preventDefault();
  const campos = Array.from(escopo.querySelectorAll(SELETOR_CAMPO))
    .filter(el => el.offsetParent !== null);
  const idx = campos.indexOf(alvo);
  if (idx === -1) return;

  const proximo = campos[idx + 1];
  if (proximo) {
    proximo.focus();
    proximo.select?.();
    return;
  }
  escopo.querySelector('[data-enter-final]')?.focus();
}
